import React, { useState } from 'react';
import { Dropdown } from 'react-bootstrap';
import { asset } from '../../../helpers/dom.helper';
import { Media, MediaContextProvider } from '../../../media';
import db from '../localDB/localDB';
import '../styles/JobOpening_style.css';
import JobCard from './JobCard';

const filter_list = db.filter_list;
const data = db.job_openings;

export default function JobOpening() {

  const [focused, setFocused] = useState('All')
  const [label, setLabel] = useState('All')
  const [isTypeOpen, setIsTypeOpen] = useState(false)

  const handleType = (type) => {
    setFocused(type)
    setLabel(type)
  }
  const filteredList = (type) => {
    switch (type) {
      case 'All':
        return data.map(list => (
          <JobCard data={list} key={list.id} />
        ))
      case type:
        let newData = data.filter(list => list.subtitle === focused)
        return newData.map(list => (
          <JobCard data={list} key={list.id} />
        ))
      default:
        console.log('null selected')
    }
  }

  return (
    <>
      <div className="jobOpening__container">
        <p className="jobOpening__title">Current Job Openings</p>

        <MediaContextProvider>
          <Media lessThan="md">
            <Dropdown id="dropdown-menu-align-right" onToggle={(isOpen) => setIsTypeOpen(isOpen)}>
              <Dropdown.Toggle className={`jobOpening__dropdown ${isTypeOpen ? 'show' : ''}`}>
                <span className="mr-auto">{label}</span>
                <img src={asset('/icon/arrow-slide-left-dark.svg')} alt="dropdown caret" className="caret" />
              </Dropdown.Toggle>
              <Dropdown.Menu>
                {filter_list.map(list => (
                  <Dropdown.Item onClick={() => handleType(list)} key={list}>{list}</Dropdown.Item>
                ))}
              </Dropdown.Menu>
            </Dropdown>

            <div className="jobOpening__card_list" id="wrap__box">
              {filteredList(focused)}
            </div>
          </Media>

          <Media greaterThanOrEqual="md">
            <div className="jobOpening__type_container">
              <p onClick={() => handleType('All')} className={focused === 'All' ? "jobOpening__type filter-active" : "jobOpening__type"}>All</p>
              <p onClick={() => handleType('Engineering')} className={focused === 'Engineering' ? "jobOpening__type filter-active" : "jobOpening__type"}>Engineering</p>
              <p onClick={() => handleType('Sale')} className={focused === 'Sale' ? "jobOpening__type filter-active" : "jobOpening__type"}>Sale</p>
              <p onClick={() => handleType('Customer Service')} className={focused === 'Customer Service' ? "jobOpening__type filter-active" : "jobOpening__type"}>Customer Service</p>
            </div>
            <div className="jobOpening__card_list" id="wrap__box">
              {filteredList(focused)}
            </div>
          </Media>
        </MediaContextProvider>
      </div>
    </>
  )

}



